import React from 'react';
import AcquireWebComponent from '../../framework/MaterialUI';
import { Row, Col, FullRow } from '../../framework/Grid/'
import { splitNumber, pdfReportHeaderDataUri, getTextSize, getDemographicText,addPdfFooter } from '../../../utils/utility'
import TrafficSummary from './TrafficSummary'
import SiteDateSelector from '../SiteDateSelector';
import ListGraphicSection from '../ListGraphic'
import OtherTraffic from './OtherTraffic';
import { Link } from 'react-router-dom'
import { Dialog } from 'material-ui'

import map from "lodash/map";
import isEmpty from "lodash/isEmpty";
import isUndefined from "lodash/isUndefined";
import findIndex from "lodash/findIndex";
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment'
import {
  getUrlParameterByName,
} from "../../../utils/utility";
import pdfConverter from 'jspdf';
import html2canvas from 'html2canvas';


import "./summary.css"

class InsightSummary extends AcquireWebComponent {
	constructor(props){
		super(props)
		const cid = getUrlParameterByName("cid");
    if (cid && (!props.selected_client || props.selected_client === '0')) {
			this.props.selectClient(parseInt(cid, 10));
			this.props.getClientSites(parseInt(cid, 10));
		}
		if (!this.props.client_sites) {
			if (cid && (!props.selected_client || props.selected_client === '0')) {
				this.props.getClientSites(parseInt(cid, 10));
			}else{
				this.props.getClientSites(props.selected_client);
			}
		}
		this.state = {
			openContactForm: false,
			state: 960,
			subject:"",
			comments: "",
			showSuccessForm: false,
			showLoadingDialog: false,
			granularity: window.localStorage.getItem('__granularity__') || 'scale',
		}
		this.props.setGranularity( window.localStorage.getItem('__granularity__') || 'scale');
	}

	componentDidMount() {
		const width = document.getElementById('insights-summary-container').clientWidth
		this.setState({ width: width })

		const { websiteId, dayRange, selected_client, getClientSites, kindOfReport, getClientProfile } = this.props;
		if (websiteId) {
			this.props.getOverviewTrafficeReport(websiteId, dayRange);
			this.props.getDomesticConsumerStats(websiteId, dayRange, this.props.granularity);
			this.props.getStatsByTime(websiteId, dayRange, undefined, kindOfReport);
			this.props.getDomesticBusinessStats(websiteId, this.props.granularity, dayRange);
		}else{
			if (selected_client) {
				getClientSites(selected_client)
				getClientProfile(selected_client)
			}
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.selected_client !== this.props.selected_client) {
			if (nextProps.selected_client > 1) {
				this.props.getClientSites(nextProps.selected_client);
				this.props.getClientProfile(nextProps.selected_client);
				this.props.clearAllDomesticStats();
				//this.props.history.push("/insights/summary?cid="+nextProps.selected_client)
			}
		}
		if ((nextProps.request_assist_successful === true) && (isUndefined(this.props.request_assist_successful))) {
			this.setState({
				subject:undefined, comments:undefined, showSuccessForm: true, openContactForm: false
			})
		}
		const change = (nextProps.websiteId !== this.props.websiteId) ||(nextProps.dayRange !== this.props.dayRange) || 
		(nextProps.granularity !== this.props.granularity);
		if (change) {
			if (nextProps.websiteId) {
				this.props.getOverviewTrafficeReport(nextProps.websiteId, nextProps.dayRange);
				this.props.getDomesticConsumerStats(nextProps.websiteId, nextProps.dayRange, nextProps.granularity);
				this.props.getStatsByTime(nextProps.websiteId, nextProps.dayRange, undefined, nextProps.kindOfReport);
				this.props.getDomesticBusinessStats(nextProps.websiteId, nextProps.granularity, nextProps.dayRange);
			}
		} else if ((nextProps.kindOfReport !== this.props.kindOfReport) && nextProps.websiteId) {
			if (nextProps.websiteId) {
				this.props.getStatsByTime(nextProps.websiteId, nextProps.dayRange, undefined, nextProps.kindOfReport);
			}
		}
	}

	getDayRangeTitle(key){
		switch (key) {
			case 'today':
				return "Today"
			case 'yesterday':
				return "Yesterday"
			case 'last-7-days':
				return 'Last 7 Days'
			case 'last-30-days':
				return 'Last 30 Days'
			case 'last-60-days':
				return 'Last 60 Days'
			case 'last-90-days':
				return 'Last 90 days'
			default:
				return ''
		}
	}

	getContent() {
		const addPercentSign = (val) => {
			return val.toFixed(2) + '%'
		}
		const { kindOfReport, overviewTrafficReport, domesticConsumerVisitsReport, domesticBusinessVisitsReport, 
			dayRange, statsByTime, client_info } = this.props

		const summaryData = {
			totalVisitsCount: 0,
			uniqueVisitsCount: 0,
			detailVisitsCount: {}
		}

		const otherTrafficData = {
			total: 0,
			unique: 0
		};

		if (overviewTrafficReport){
			otherTrafficData.total = overviewTrafficReport.totalVisits || 0;
			otherTrafficData.unique = overviewTrafficReport.uniqueVisits || 0;
			summaryData.totalVisitsCount = overviewTrafficReport.totalVisits;
			summaryData.uniqueVisitsCount = overviewTrafficReport.uniqueVisits;
			summaryData.detailVisitsCount = {};
			map(overviewTrafficReport.stats, (stats) => {
				summaryData.detailVisitsCount[stats.type] =  (stats.totalPercentage * 100).toFixed(2) + "%";
			})
		}

		const timeTraffic = []
		if (statsByTime) {
			map(statsByTime.stats, (obj) => {
				let timeStr = ''
				switch (dayRange) {
					case 'yesterday':
					case 'today':
						timeStr = moment(obj.type).format("hA")
						break
					default:
						timeStr = moment(obj.type, 'YYYY-MM-DD').format("MMM-DD")
				}
				const item = { time: timeStr, totalVisits: obj.total, uniqueVisits: obj.unique }
				timeTraffic.push(item)
			})
		}

		let consumerData = []
		if (domesticConsumerVisitsReport) {
			consumerData = []
			map(domesticConsumerVisitsReport, (stat, key) => {
				if (key === 'maritalStats')
					return
				let title = getDemographicText(key.replace("Stats", ""))
				if (key === "totalVisits")
					title = "Total Consumer Visits"
				if (key === "uniqueVisits")
					title = "Unique Consumer Visits"
				let valText = ''
				if (Array.isArray(stat)) {
					if (stat.length > 1) {
						stat.forEach(function (item) {
							switch (key) {
								case "genderStats":
									if (isEmpty(valText))
										valText = addPercentSign(item.value * 100) + ' (' + item.key + ') - '
									break;								
								default:
									valText += addPercentSign(item.value * 100) + ' (' + item.key + ') - '
							}
						})
						valText = valText.substring(0, valText.length - 2)
					} else {
						valText = stat.length > 0 ? key === 'genderStats' ? addPercentSign(stat[0].value * 100) + ' (' + stat[0].key + ')' : addPercentSign(stat[0].value * 100) : ""
					}
				} else {
					switch (key) {
						case 'medianAge':
							valText = Math.round(stat) + ''
							break
						case 'medianNumberOfPeople':
							valText = Math.round(stat * 10) / 10 + ''
							break
						case 'medianIncome':
							valText = '$' + splitNumber(Math.round(stat))()
							break;
						case 'totalVisits':
						case 'uniqueVisits':
							valText = splitNumber(stat)();
							break;
						default:
							valText = stat + ''
					}
				}
				if ((valText === "0") || (isEmpty(valText)) || (valText === 'null') || (valText === "$0")){
					valText = 'N/A'
					if (this.props.client_sites && Array.isArray(this.props.client_sites) && this.props.client_sites.length > 0){
						const site_name = this.props.client_sites[0].label
						if (site_name === 'Auto Inc.'){
							switch (key) {
								case 'medianAge':
									valText = '50'
									break
								case 'medianNumberOfPeople':
									valText = '2.3'
									break
								case 'medianIncome':
									valText = '$' + splitNumber(47965)()
									break
								case 'homeOwnershipStats':
									valText = '52.56%'
									break
								case 'genderStats':
									valText = '46.30% (M)'
									break
								default:
									valText = '';
									break
							}
						}
					}
				}
				consumerData.push({ name: title, value: valText })
			})
			const total = domesticConsumerVisitsReport.totalVisits || 0;
			const unique = domesticConsumerVisitsReport.uniqueVisits || 0;
			otherTrafficData.total = otherTrafficData.total - total;
			otherTrafficData.unique = otherTrafficData.unique - unique;
			if (kindOfReport === 'consumer') {
				otherTrafficData.total = total;
				otherTrafficData.unique = unique;
			}
		}

		let businessData = []
		const initData = [
			{name:"Total Business Visits", value:"Unknown"},
			{name:"Unique Business Visits", value:"Unknown"},
			{name:"Top Industry", value:"Unknown"},
			{name:"Average Annual Company Revenue", value:'Unknown'},
			{name:"Average Number of Company Employees", value:'Unknown'},
			{name:"Average Age of Business", value:"Unknown"},
			{name:"Home Business", value:"Unknown"}
		]
		if (domesticBusinessVisitsReport) {
			businessData = cloneDeep(initData);
			const total = domesticBusinessVisitsReport.totalVisits || 0;
			const unique = domesticBusinessVisitsReport.uniqueVisits || 0;
			if (kindOfReport === 'business') {
				otherTrafficData.total = total;
				otherTrafficData.unique = unique;
			} else if (kindOfReport !== 'consumer') {
				otherTrafficData.total = otherTrafficData.total - total;
				otherTrafficData.unique = otherTrafficData.unique - unique;
			} 
			map(domesticBusinessVisitsReport, (stats, key) => {
				let title = "";
				let valText = "";
				switch (key) {
					case 'totalVisits':
						title = 'Total Business Visits'
						valText = splitNumber(stats)();
						break;
					case 'uniqueVisits':
						title = 'Unique Business Visits'
						valText = splitNumber(stats)();
						break;
					case 'topIndustry':
						title = 'Top Industry';
						valText = stats;
						break;
					case 'averageBizAge':
						title = 'Average Age of Business';
						valText = stats ? stats.toFixed(2) + " years" : "N/A";
						break;
					case 'averageEmployees':
						title = 'Average Number of Company Employees'
						valText = stats ? isNaN(stats) ? "N/A" : splitNumber(parseInt(stats, 10))() : "N/A";
						break;
					case 'averageRevenue':
						title = 'Average Annual Company Revenue';
						valText = stats ? isNaN(stats) ? "N/A" : "$" + splitNumber(stats)() : "N/A";
						break;
					case 'homeBizPercentage':
						title = "Home Business";
						valText = stats === 0 ? "Unknown" : addPercentSign(stats * 100)
						break;
					default:
						title =  "";
				}
				if ((valText === "0") || (isEmpty(valText)))
					valText = "Unknown";
				const idx = findIndex(businessData, {name: title});
				businessData.splice(idx, 1, {name: title, value: valText});
			});

			if (isEqual(businessData, initData)){
				businessData = [];
			}
		}
		
		if (kindOfReport === 'consumer') {
			return (
				<div className="website-visits-content summary-consumer" style={{padding: 0}}>
					<OtherTraffic 
						{...otherTrafficData} 
						totalTitle="Total Visits"
						uniqueTitle="Unique Visits"
						title="Domestic Consumer Site Traffic" 
						discription="Domestic consumer traffic only, excludes foreign and bot traffic" 
					/>
					<div className="total-visit-section">
						{this.state.showLoadingDialog === true ? 
						<TrafficSummary client_profile={client_info} data={summaryData} hideTraffic={true} chartTitle={'Total U.S. Domestic Consumer Traffic'} lineData={timeTraffic} key={'total-visit-section'} dateRange={this.getDayRangeTitle(this.props.dayRange)} /> :
						<TrafficSummary client_profile={client_info} data={summaryData} hideTraffic={true} chartTitle={'Total U.S. Domestic Consumer Traffic'} lineData={timeTraffic} handleContactSupport={() => {this.setState({openContactForm: true})}} 
							key={'total-visit-section'} dateRange={this.getDayRangeTitle(this.props.dayRange)} />
						}
					</div>
					<div className="light-grey-border mb-20 pb-20 mt-20 clear-float">
						<div className="p-20">
							<ListGraphicSection data={consumerData} 
								footer={this.state.showLoadingDialog === true ? null : <Link className="traffic-link" style={{position:"absolute", left:"0px", bottom:"-5px"}} to={"/insights/consumer?nav=overview&cid="+this.props.selected_client}>View More Consumer Information</Link>}
								title={"Domestic Consumer Traffic"} />
						</div>
					</div>
				</div>
			);
		} else if (kindOfReport === 'business') {
			return (
				<div className="website-visits-content summary-business" style={{padding: 0}}>
					<OtherTraffic
						{...otherTrafficData}
						totalTitle="Total Visits"
						uniqueTitle="Unique Visits"
						title="Domestic Business Site Traffic"
						discription="Domestic business traffic only, excludes foreign and bot traffic"
					/>
					<div className="total-visit-section">
						{this.state.showLoadingDialog === true ? 
						<TrafficSummary client_profile={client_info} data={summaryData} hideTraffic={true} chartTitle={'Total U.S. Domestic Business Traffic'} lineData={timeTraffic} key={'total-visit-section'} dateRange={this.getDayRangeTitle(this.props.dayRange)} /> :
						<TrafficSummary client_profile={client_info} data={summaryData} hideTraffic={true} chartTitle={'Total U.S. Domestic Business Traffic'} lineData={timeTraffic} handleContactSupport={() => {this.setState({openContactForm: true})}} 
							key={'total-visit-section'} dateRange={this.getDayRangeTitle(this.props.dayRange)} />
						}
					</div>
					<div className="light-grey-border mb-20 pb-20 mt-20 clear-float">
						<div className="p-20">
							<ListGraphicSection data={businessData} title={"Domestic Business Traffic"}
										footer={this.state.showLoadingDialog === true ? null : <Link className="traffic-link" style={{position:"absolute", left:"0px", bottom:"-5px"}} to={"/insights/business?nav=overview&cid="+this.props.selected_client}>View More Business Information</Link>} 
									/>
						</div>
					</div>
				</div>
			);
		} else {
			return (
				<div className="website-visits-content" style={{padding: 0}}>
					{/*
						<FullRow className="text-right no-padding mb-20 no-margin-top">
							<button type="button" onClick={(e) => {this.downloadAsPdf()}} className="btn btn-default legitRipple btn-aa-default" >
										Download AS PDF
							</button>
						</FullRow>
					*/}
						<div className="total-visit-section">
							{this.state.showLoadingDialog === true ? 
							<TrafficSummary client_profile={client_info} data={summaryData} lineData={timeTraffic} key={'total-visit-section'} dateRange={this.getDayRangeTitle(this.props.dayRange)} /> :
							<TrafficSummary client_profile={client_info} data={summaryData} lineData={timeTraffic} handleContactSupport={() => {this.setState({openContactForm: true})}} 
								key={'total-visit-section'} dateRange={this.getDayRangeTitle(this.props.dayRange)} />
							}
						</div>
						<div className=" bg-white demo-geo-section">
							<Row className="pt-20 pb-20 pr-10 pl-10 no-margin-bottom" style={{ minHeight: '250px', display:"flex" }}>
								<div className="p-20 light-grey-border" style={{flex:"1 1"}}>
									<ListGraphicSection data={consumerData} 
										footer={this.state.showLoadingDialog === true ? null : <Link className="traffic-link" style={{position:"absolute", left:"0px", bottom:"-5px"}} to={"/insights/consumer?nav=overview&cid="+this.props.selected_client}>View More Consumer Information</Link>}
										title={"Domestic Consumer Traffic"} />
								</div>
								<div style={{width:"20px"}}></div>
								<div className="p-20 light-grey-border" style={{flex:"1 1"}}>
									<ListGraphicSection data={businessData} title={"Domestic Business Traffic"}
										footer={this.state.showLoadingDialog === true ? null : <Link className="traffic-link" style={{position:"absolute", left:"0px", bottom:"-5px"}} to={"/insights/business?nav=overview&cid="+this.props.selected_client}>View More Business Information</Link>} 
									/>
								</div>
							</Row>
						</div>
						<OtherTraffic {...otherTrafficData}/>
				</div>
			);
		}
	}

	onContactFormSubmit(e) {
		e.preventDefault();
		const postData = {
			"clientId": this.props.selected_client,
			"subject": this.state.subject.trim(),
			"comment": this.state.comments.trim(),
			"originationPage":"Main Insights Dashboard"
		}
		
		this.props.sendAssistRequest(postData);
	}

	downloadAsPdf(){
		this.setState({showLoadingDialog: true})

		const {selected_client, client_sites, websiteId, clients, dayRange} = this.props
		let c = clients.find(function(client){
			return parseInt(client.id,10) === parseInt(selected_client, 10)
		})
		if (!c){
			clients.forEach(function(cl){
				if (cl.businessUnits){
					cl.businessUnits.forEach(function(b){
						if (parseInt(b.id, 10) === parseInt(selected_client, 10))
							c = b
					})
				}
			})
		}

		const clientName = c && c.name ? c.name : ""
		const s = client_sites.find(function(site){
			return site.value === websiteId
		})

		const fileName = clientName + '_insights_' + dayRange.replace(/-/g, '_') + '_' + 
			moment().format('YYYYMMDD') + '.pdf'

		const pdf = new pdfConverter('p', 'mm', 'a4')
		pdf.setFont("helvetica")
		pdf.setFontType("normal")
		pdf.setFontSize(9)
		const pageWidth = 186
		let totalVisitsCanva = null, listDataCanva =null
		let isTotalVisitReady = false, isListDataReady = false

		let els = document.getElementsByClassName("total-visit-section")
		if (els.length > 0){
			const el = els[0]
			const tvWidth = el.offsetWidth
			el.style.width = '1024px'
      setTimeout(function () {
        html2canvas(el, {logging:false}).then(function (canvas) {
					totalVisitsCanva = canvas
					isTotalVisitReady = true
					el.style.width = tvWidth + 'px'
			 	})
      }, 50);
		}

		els = document.getElementsByClassName("demo-geo-section")
		if (els.length > 0){
			const el = els[0]
			const tvWidth = el.offsetWidth
			el.style.width = '1024px'
      setTimeout(function () {
        html2canvas(el, {logging:false}).then(function (canvas) {
					listDataCanva = canvas
					isListDataReady = true
					el.style.width = tvWidth + 'px'
			 	})
      }, 50);
		}

		let top = 10
		let intervalId = setInterval(function () {
			if ((isTotalVisitReady === false) || (isListDataReady === false)){
				console.log('PDF generating...')
			}else{
				clearInterval(intervalId)	
				//pdf.setDrawColor(0, 123, 99)
				setTimeout(function(){
					/*
					pdf.setFillColor(232,232,232)
					pdf.rect(0, 12 , 210, 15, 'F')
					
					pdf.setTextColor(255, 255, 255)
					//pdf.rect(0, 0, 210, 15, 'F')
					pdf.setFontSize(9)
					pdf.addImage(insightHeaderDataUri(), 'PNG', 0, 0, 210, 0)
					pdf.text(198, 8, moment().format('MMMM DD, YYYY'), null, null, 'right')*/
					pdf.setFillColor(127,127,127);
					pdf.rect(0, 15 , 210, 10, 'F');
			
					pdf.setTextColor(0, 0, 0)
					pdf.setFontSize(9)
					pdf.setFontType('bold')
					pdf.addImage(pdfReportHeaderDataUri(), 'PNG', 10.5, 3, 60, 0)
					pdf.text(198, 8, moment().format('MMMM DD, YYYY'), null, null, 'right');
	
					pdf.setTextColor(255, 255, 255)
					pdf.setFontType('bold')
					pdf.text(12, 21, 'Client:')			
					const lenClientName = getTextSize(clientName.trim(), 'helvetica') 
					pdf.setFontType('normal')
					pdf.text(23, 21, clientName.trim())
					//cm to inches
					let start = 23 + lenClientName.width * 0.3937 + 0.4
					pdf.setFontType('bold')
					pdf.text(start, 21, 'WEBSITE NAME:')
					start += 26.5
					pdf.setFontType('normal')
					pdf.text(start, 21, s && s.label ? s.label.trim() : '')
					start += s && s.label ? (getTextSize(s.label.trim(), 'helvetica')).width * 0.3937 + 0.4 : 1
					pdf.setFontType('bold')
					pdf.text(start, 21, 'Date:')
					pdf.setFontType('normal')
					start += (getTextSize('Date:', 'helvetica')).width * 0.3937 + 0.4
					pdf.text(start, 21, this.getDayRangeTitle(dayRange))

					pdf.setFillColor(255)
					pdf.setLineWidth(0.1)
					pdf.line(0, 27, 210, 27)
					top =  32
					
					pdf.addImage(totalVisitsCanva.toDataURL(), 'PNG', 12, top, pageWidth, 0)
					pdf.setLineWidth(0.03)
					const h1 = totalVisitsCanva.height * pageWidth / totalVisitsCanva.width
					top += h1 + 5

					pdf.addImage(listDataCanva.toDataURL(), 'PNG', 12, top, pageWidth, 0)
					const h2 = listDataCanva.height * pageWidth / listDataCanva.width
					top += h2 + 5
					/*
					pdf.setFillColor(35, 47, 58)
					pdf.rect(0, 280, 210, 20, 'F')
					pdf.addImage(pdfReportFooterDataUri(), 'PNG', 15, 290, 20, 0)

					pdf.setTextColor(255, 255, 255)
					pdf.setFontSize(9)
					pdf.setFontType('bold')
					pdf.text(65, 290, moment().format('YYYY') + " Claritas, LLC. All rights reserved")*/
					addPdfFooter(pdf);
					pdf.save(fileName)

					this.setState({showLoadingDialog: false})		
				}.bind(this), 100)
			}
		}.bind(this), 50)
	}

	handleNavClick(nav) {
		const { kindOfReport } = this.props;
		const cid = getUrlParameterByName("cid");
		const cidUrl = cid ? `?cid=${cid}` : '';
		if (nav === 'total' && kindOfReport !== undefined) {
			this.props.history.push('/insights/summary' + cidUrl);
		} else if (nav === 'consumer' && kindOfReport !== 'consumer') {
			this.props.history.push('/insights/summary/consumer' + cidUrl);
		} else if (nav === 'business' && kindOfReport !== 'business') {
			this.props.history.push('/insights/summary/business' + cidUrl);
		}
	}

	randerNavClass(nav) {
		const { kindOfReport } = this.props;
		if (nav === kindOfReport) {
			return 'nav nav-active';
		} else {
			return 'nav';
		}
	}

	render() {
		const { websiteId, client_sites, loadingOverviewTraffic, loadingDomesticBusiness, kindOfReport,
			loadingDomesticConsumerVisits, loadingStatsByTime } = this.props;
		const dataLoading = (!!loadingDomesticConsumerVisits) || (!!loadingOverviewTraffic) || (!!loadingDomesticBusiness)
			|| (!!loadingStatsByTime);
		const actionButtons = [
			this.props.send_assist_request_error &&
			<div className="pull-left ml-20 mt-5" style={{fontWeight:"bold", color:"#FF0000"}}>
				{this.props.send_assist_request_error}
			</div>,
			<button onClick={() => {this.setState({openContactForm: false})}} className="btn btn-default btn-aa-info mr-10">Cancel</button>,
			(isEmpty(this.state.comments) || isEmpty(this.state.subject)) ?
			<button disabled className="btn btn-default btn-aa-info mr-10">Submit</button> :
			<button onClick={(e) =>{this.onContactFormSubmit(e)}} className="btn btn-aa-default mr-10">Submit</button>
		]
		return (
			<div id="insights-summary-container" style={{fontFamily:"Arial", fontSize:"16px"}}>
				<div style={{ padding: '0', margin: "-20px auto 10px", width: '80vw'}} >
					<SiteDateSelector showGranularity={kindOfReport === 'consumer'} granularityChanged={this.props.setGranularity} 
					granularity={this.props.granularity}
					websiteIdChanged={this.props.setWebsiteId} siteId={websiteId} type={"larger"}
						sites={this.props.client_sites} dayRangeChanged={this.props.setDateRange} dayRange={this.props.dayRange}/>
				</div>
				<div className="summary-content">
					<ul className="nav-list light-grey-border">
						<li className={this.randerNavClass()} onClick={this.handleNavClick.bind(this, 'total')}>Total</li>
						<li className={this.randerNavClass('consumer')} onClick={this.handleNavClick.bind(this, 'consumer')}>Consumer</li>
						<li className={this.randerNavClass('business')} onClick={this.handleNavClick.bind(this, 'business')}>Business</li>
					</ul>
					<div style={{flexGrow: 1}}>{this.getContent()}</div>
				</div>
				<Dialog open={this.state.showLoadingDialog || (dataLoading === true)}
						style={{top: '-1.8em'}}
						overlayStyle={{opacity: 0.9, backgroundColor:'#666666'}}
						modal={true}>
						<Row className="mt-20">
							<Col xs="7" sm="7" md="7" lg="7" className="text-right">
								<div>{dataLoading ? "Loading" : "Downloading"}, please wait...</div>
							</Col>
							<Col xs="1" sm="1" md="1" lg="1">
								<img alt="" src="/Spinner.gif" style={{ height: "24px" }} />
							</Col>
						</Row>
					</Dialog>
			</div>
		)
	}
}

export default InsightSummary


// WEBPACK FOOTER //
// ./src/components/Insights/summary/index.jsx